import { ApplicationRef, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { LocalStorageService } from '../localStorage/local-storage.service';
import { Socket } from 'ngx-socket-io';

@Injectable({
    providedIn: 'root'
})
export class SocketNotifications extends Socket {
    constructor(
        private localStorageService: LocalStorageService,
        appRef: ApplicationRef
    ) {
        const userRaw = localStorage.getItem('currentUser') || '{}';
        let userDetails: any = {};
        try {
            userDetails = JSON.parse(userRaw);
        } catch (error) {
            console.error(error);
        }
        super({
            url: environment.chatBaseUrl,
            options: {
                transports: ['websocket'],
                reconnection: false,
                forceNew: true,
                timeout: 5000,
            },
        },
            appRef
        );
    }
}
